import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://mmffexfmyqrdimcbdrdn.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1tZmZleGZteXFyZGltY2JkcmRuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIyNzYyNDksImV4cCI6MjA3Nzg1MjI0OX0.kgJNnv4VzNti7l7p6Xh6zj3HZfN5Zcp84TOG0Atz8N0';

// Log for debugging (remove in production)
console.log('Supabase URL:', supabaseUrl);
console.log('Supabase Key exists:', !!supabaseAnonKey);

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Helper to handle Supabase errors
export const handleSupabaseError = (error) => {
  if (error) {
    console.error('Supabase error:', error);
    throw new Error(error.message || 'An error occurred');
  }
};
